import React, { useState } from 'react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from './ui/sheet';
import { Filter, X } from 'lucide-react';

export const MobileFilterButton = ({ children, filterCount = 0, onClearAll }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="lg:hidden fixed bottom-6 left-0 right-0 z-40 flex justify-center">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button 
            className="bg-blue-600 hover:bg-blue-700 text-white shadow-xl rounded-full px-8 h-12 text-sm font-semibold"
          >
            <Filter className="h-4 w-4 mr-2" />
            Filters
            {filterCount > 0 && (
              <span className="ml-2 bg-white text-blue-600 rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                {filterCount}
              </span>
            )}
          </Button>
        </SheetTrigger>
        <SheetContent side="bottom" className="h-[90vh] rounded-t-2xl p-0">
          <SheetHeader className="p-4 border-b sticky top-0 bg-blue-600 z-10 rounded-t-2xl">
            <div className="flex items-center justify-between">
              <SheetTitle className="text-lg font-bold text-white">All Filters</SheetTitle>
              {filterCount > 0 && (
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={onClearAll}
                  className="text-blue-100 hover:text-white hover:bg-white/10 text-sm"
                >
                  Clear All
                </Button>
              )}
            </div>
          </SheetHeader>
          <div 
            className="overflow-y-auto p-4 bg-white" 
            style={{ 
              height: 'calc(90vh - 140px)',
              scrollbarWidth: 'thin',
              scrollbarColor: '#3b82f6 #f1f5f9',
              paddingBottom: '100px'
            }}
          >
            {children}
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-white border-t shadow-lg">
            <Button 
              className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-base font-semibold"
              onClick={() => setOpen(false)}
            >
              Show Results
            </Button>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};
